import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  useLocalStorage,
} from '@makeably/creativex-design-system';
import ExplorerSearch from 'components/internal/explorer/ExplorerSearch';
import Results from 'components/internal/explorer/Results';
import { resultProps } from 'components/internal/explorer/shared';
import {
  getParams,
  redirectWithParamsObj,
  setParam,
} from 'utilities/url';

const propTypes = {
  input: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(resultProps).isRequired,
};

function Explorer({ input, results }) {
  const params = getParams(window);
  const [search, setSearch] = useState(input);
  const [searchBy, setSearchBy] = useLocalStorage('cxIntExplorerSearchBy', 'user');

  useEffect(() => {
    const param = params.get('search_by');
    if (param) {
      setSearchBy(param);
    }
  }, [params]);

  const handleSearchBy = (value) => {
    setSearchBy(value);
    setParam('search_by', value, params, window);
  };

  const handleSearch = () => {
    const paramsObj = {
      input: search,
      search_by: searchBy,
    };
    redirectWithParamsObj(paramsObj, params, window);
  };

  return (
    <Card className="u-flexColumn u-gap-24">
      <ExplorerSearch
        search={search}
        searchBy={searchBy}
        onSearch={handleSearch}
        onSearchByChange={handleSearchBy}
        onSearchChange={setSearch}
      />
      <div>
        <div className="t-overline u-marginBottom-8">Results</div>
        <Results results={results} />
      </div>
    </Card>
  );
}

Explorer.propTypes = propTypes;

export default Explorer;
